/* eslint-disable no-restricted-imports */
import {
  type ExtendButtonBase,
  styled,
  ToggleButton as MuiToggleButton,
  ToggleButtonGroup as MuiToggleButtonGroup,
  type ToggleButtonGroupProps,
  type ToggleButtonTypeMap
} from "@mui/material";
import { createContext, forwardRef, useContext } from "react";
import CheckIcon from "@mui/icons-material/Check";
/* eslint-enable no-restricted-imports */

export const ToggleButton = forwardRef(({ children, ...props }, ref) => {
  const value = useContext(ToggleButtonGroupContext);
  const showCheckmarks = useContext(ShowCheckmarksContext);
  const selected = isValueSelected(props.value as string, value);

  const startIcon = showCheckmarks && selected && (
    <ButtonStartIcon>
      <CheckIcon />
    </ButtonStartIcon>
  );

  return (
    <MuiToggleButton {...props} ref={ref}>
      {startIcon}
      {children}
    </MuiToggleButton>
  );
}) as ExtendButtonBase<ToggleButtonTypeMap>;

const ButtonStartIcon = styled("span")(({ theme }) => ({
  display: "inherit",
  marginRight: 8,
  "& > *:nth-of-type(1)": {
    fontSize: 18,
  },
}));

export const ToggleButtonGroup = forwardRef<HTMLDivElement, ToggleButtonGroupProps>(
  ({ showCheckmarks, value, ...props }, ref) => {
    return (
      <ToggleButtonGroupContext.Provider value={value}>
        <ShowCheckmarksContext.Provider value={showCheckmarks}>
          <MuiToggleButtonGroup ref={ref} value={value} {...props} />
        </ShowCheckmarksContext.Provider>
      </ToggleButtonGroupContext.Provider>
    );
  },
);

const ShowCheckmarksContext = createContext<boolean | undefined>(false);
const ToggleButtonGroupContext = createContext<string | undefined>(undefined);

function isValueSelected(value: any, candidate: any) {
  if (candidate === undefined || value === undefined) {
    return false;
  }
  if (Array.isArray(candidate)) {
    return candidate.includes(value);
  }
  return value === candidate;
}
